<template>
  <div>
    <!-- FORM ELEMENTS -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              FORM ELEMENTS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <b-row class="mt-4">
              <div class="col-3">
                <h2>
                  Input Type [text]
                </h2>
              </div>
            </b-row>
            <b-row class="mt-2">
              <div class="col-3">
                <p class="bold mt-4">
                  Placeholder Style
                </p>
                <b-form-input class="mt-3"
                              type="text"
                              placeholder="Input content"
                />
              </div>
              <div class="col-3">
                <p class="bold mt-4">
                  Filled Style
                </p>
                <b-form-input class="mt-3"
                              value="Input content"
                              type="text"
                              placeholder="Input content"
                />
              </div>
            </b-row>
            <b-row class="mt-2">
              <div class="col-3">
                <p class="bold mt-4">
                  Input with Label
                </p>
                <b-form-group id="fieldset1"
                              class="mt-3"
                              label="Label text"
                              label-for="input1"
                >
                  <b-form-input id="input1" />
                </b-form-group>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-6">
                <h2>
                  Input Type [checkbox] & Input Type [radio]
                </h2>
              </div>
            </b-row>
            <b-row class="mt-2">
              <div class="col-2">
                <p class="bold mt-4">
                  Disabled
                </p>
                <b-form-checkbox id="checkbox1"
                                 class="checkbox-1 mt-3"
                                 :disabled="true"
                                 value="checbox1"
                >
                  Content
                </b-form-checkbox>
              </div>
              <div class="col-2">
                <p class="bold mt-4">
                  Selected
                </p>
                <b-form-checkbox id="checkbox2"
                                 class="checkbox-1 mt-3"
                                 value="checbox2"
                >
                  Content
                </b-form-checkbox>
              </div>
              <div class="col-2">
                <p class="bold mt-4">
                  Selected & Bold
                </p>
                <b-form-checkbox id="checkbox3"
                                 class="checkbox-1 mt-3 bold"
                                 value="checbox3"
                >
                  Content
                </b-form-checkbox>
              </div>
              <div class="col-3">
                <p class="bold mt-4">
                  Checkbox or Radio in Input Box
                </p>
                <div class="button-select-group mt-3 bg-white">
                  <div class="row">
                    <div class="col-6">
                      <b-form-checkbox id="checkbox4"
                                       :disabled="true"
                                       class="checkbox-1 ml-3 mt-2 mb-2"
                                       value="accepted"
                      >
                        Content
                      </b-form-checkbox>
                    </div>
                    <div class="col-6">
                      <b-form-checkbox id="checkbox5"
                                       class="checkbox-1 ml-3 mt-2 mb-2"
                                       value="accepted"
                      >
                        Content
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <p class="bold mt-4">
                  Checkbox or Radio in Input Box w/ Label
                </p>
                <div class="form-group">
                  <label class="col-form-label">Input with Label</label>
                  <div class="button-select-group bg-white">
                    <div class="row">
                      <div class="col-6">
                        <b-form-checkbox id="checkbox6"
                                         :disabled="true"
                                         class="checkbox-1 ml-3 mt-2 mb-2"
                                         value="accepted"
                        >
                          Content
                        </b-form-checkbox>
                      </div>
                      <div class="col-6">
                        <b-form-checkbox id="checkbox7"
                                         class="checkbox-1 ml-3 mt-2 mb-2"
                                         value="accepted"
                        >
                          Content
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-row>
            <b-row class="mt-2">
              <b-form-radio-group id="radios2"
                                  v-model="selected"
                                  class="col-12"
                                  name="radioSubComponent"
              >
                <div class="row">
                  <div class="col-2">
                    <p class="bold mt-4">
                      Disabled
                    </p>
                    <b-form-radio value="first"
                                  disabled
                    >
                      content
                    </b-form-radio>
                  </div>
                  <div class="col-2">
                    <p class="bold mt-4">
                      Selected
                    </p>
                    <b-form-radio value="second">
                      content
                    </b-form-radio>
                  </div>
                  <div class="col-2">
                    <p class="bold mt-4">
                      Selected & Bold
                    </p>
                    <b-form-radio value="third">
                      content
                    </b-form-radio>
                  </div>
                </div>
              </b-form-radio-group>
            </b-row>
            <b-row class="mt-5">
              <div class="col-6">
                <h2>
                  Slider
                </h2>
              </div>
            </b-row>
            <b-row class="mt-3">
              <div class="col-4">
                <vue-slider ref="sliderAgeRange"
                            v-bind="experienceRangeConfigs"
                            :value="experienceRangeConfigs.value"
                            @callback="filter_setAgeRangeValue"
                />
              </div>
            </b-row>
            <b-row class="mt-5">
              <div class="col-10">
                <vue-slider ref="sliderAgeRange"
                            v-bind="experienceRangeConfigs"
                            :value="experienceRangeConfigs.value"
                            @callback="filter_setAgeRangeValue"
                />
              </div>
            </b-row>
            <b-row class="mt-5">
              <div class="col-6">
                <h2>
                  Switch Element
                </h2>
              </div>
            </b-row>
            <b-row class="mt-3">
              <div class="col-3">
                <p class="bold">
                  With Right Content
                </p>
                <div class="mt-3">
                  <switches v-model="enabled"
                            class="switch"
                            theme="bootstrap"
                            color="purple"
                            type-bold="true"
                  />
                </div>
              </div>
              <div class="col-3">
                <p class="bold">
                  With Left Content
                </p>
                <div class="mt-3">
                  <switches v-model="enabled"
                            class="switch"
                            theme="bootstrap"
                            color="purple"
                            type-bold="true"
                  />
                </div>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
import vueSlider from 'vue-slider-component';
import switches from 'vue-switches';

export default {
  name: 'FormElement',
  components: {
    vueSlider,
    switches,
  },
  data() {
    return {
      experienceRangeConfigs: {
        piecewise: true,
        piecewiseLabel: true,
        isCollapsed: true,
        labelText: 'Tecrübe Yılı',
        width: '100%',
        show: true,
        min: 0,
        max: 10,
        data: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        value: [0, 10],
        formatter: (value) => {
          if (value === 0) {
            return '0';
          } if (value >= 10) {
            return `${value}+`;
          }
          return `${value}`;
        },
        piecewiseStyle: {
          backgroundColor: '#ccc',
          visibility: 'visible',
          width: '12px',
          height: '12px',
        },
        piecewiseActiveStyle: {
          backgroundColor: '#3498db',
        },
        labelActiveStyle: {
          color: '#3498db',
        },
        tooltipStyle: {
          display: 'none',
        },
      },
      enabled: true,
      selected: 'second',
      status: 'not_accepted',
      options1: [{ text: 'content', value: 'first', disabled: true }],
      options2: [{ text: 'content', value: 'second' }],
      options3: [{ text: 'content', value: 'third' }],
    };
  },
  computed: {},
  methods: {
    filter_setAgeRangeValue() {
    },
  },
};
</script>
